import React from "react";
import {IconButton, TableCell, TableRow} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import IconDelete from "@material-ui/icons/Delete";
import {IGrnItemRow} from "./IGrnItems";

interface IProps {
	igrnItem: IGrnItemRow,
	index: number,
	onEdit: () => void,
	onDelete: () => void,
	accepted: boolean,
}

const IGrnItemsTableRow: React.FC<IProps> = (props: IProps) => {

	const {igrnItem, index, onEdit, onDelete, accepted} = props;

	return (
		<TableRow>
			<TableCell>{index + 1}</TableCell>
			<TableCell>{igrnItem.partNumber}</TableCell>
			<TableCell>{igrnItem.descriptionEn}</TableCell>
			<TableCell style={{textAlign: "center"}}>{igrnItem.quantity}</TableCell>
			<TableCell style={{textAlign: "center"}}>{igrnItem.unitName}</TableCell>
			<TableCell style={{textAlign: "center"}}>{(igrnItem.totalValue / 10000).toFixed(
				2)}</TableCell>
			<TableCell style={{width: 152, textAlign: "center"}}>
				{
					!accepted &&
					<>
						<IconButton size={"small"} onClick={onEdit}>
							<EditIcon/>
						</IconButton>
						<IconButton size={"small"} onClick={onDelete}>
							<IconDelete/>
						</IconButton>
					</>
				}
			</TableCell>
		</TableRow>
	);
};

export default IGrnItemsTableRow
